import { LineChart, Line, ResponsiveContainer } from 'recharts';

interface Props {
  label: string;
  value: string;
  data: number[];
  trend?: { value: string; positive: boolean } | null;
}

export default function SparklineCard({ label, value, data, trend }: Props) {
  const chartData = data.map((v, i) => ({ i, v }));

  return (
    <div
      className="rounded p-4 transition-colors"
      style={{ border: '1px solid var(--dash-border)', background: 'var(--dash-card)' }}
      onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--dash-card-hover)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--dash-card)'; }}
    >
      <div className="font-mono text-[10px] uppercase tracking-widest mb-1.5" style={{ color: 'var(--dash-text-muted)' }}>
        {label}
      </div>
      <div className="flex items-end justify-between gap-3">
        <div>
          <div className="font-mono text-xl mb-1" style={{ color: 'var(--dash-text-primary)' }}>{value}</div>
          {trend && (
            <div className={`flex items-center gap-1 text-xs font-sans ${trend.positive ? 'text-emerald-400' : 'text-red-400'}`}>
              <span className="text-[11px]">{trend.positive ? '\u2191' : '\u2193'}</span>
              {trend.value}
            </div>
          )}
        </div>
        {chartData.length > 1 && (
          <div className="w-20 h-8">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={chartData}>
                <Line
                  type="monotone"
                  dataKey="v"
                  stroke="#3b82f6"
                  strokeWidth={1.5}
                  dot={false}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}
